<template>
  <div
    class="w-full md:flex md:justify-center md:items-center py-4 md:py-8 lg:py-10 pt-5"
  >
    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-gray-100"></div>
    <section class="w-full max-w-7xl mx-auto px-5 py-2 md:p-4 2xl:p-0 lg:mt-5">
      <div class="w-full 2xl:w-[1280px] mx-auto flex flex-col gap-2 md:gap-5">
        <div v-for="el in electiveData.slice(0, 1)" :key="el.id">
          <h2
            class="hidden md:block text-[24px] lg:text-[35px] text-[#1f1f1f] font-semibold text-left"
          >
            Online {{ el.program.short_name }} Electives
          </h2>
          <h2
            class="block md:hidden text-[24px] text-[#1f1f1f] font-semibold text-left"
          >
            Online {{ el.program.short_name }} Electives
          </h2>
        </div>
        <div
          class="flex justify-start gap-[10px] md:gap-[25px] 2xl:gap-[30px] flex-wrap md:px-3 2xl:px-5 py-3"
        >
          <div
            class="flex flex-col gap-2 rounded-md relative h-auto w-full md:w-[363px] lg:w-[390px]"
            v-for="el in visibleElectiveData"
            :key="el.id"
          >
            <div class="h-auto">
              <!-- desktop master degrees -->
              <div class="mx-auto hidden md:block h-full relative">
                <a
                      :href="`/${el.program.short_slug}/${el.slug}`"
                    >
                <img
                  :src="el.elective_desktop_image"
                  :alt="el.name"
                  class="rounded-[25px] md:rounded-[25px] shadow-xl h-full object-cover"
                />
                <div
                  class="absolute bottom-4 h-auto min-h-[160px] flex flex-col gap-2 p-4"
                >
                  <h2 class="text-white text-[22px] font-medium text-start">
                    {{ el.name }}
                  </h2>
                  <p
                    class="text-white text-[14px] font-medium text-start line-clamp-2"
                    v-html="el.description"
                  ></p>
                  <div
                    class="flex gap-4 md:gap-6 lg:gap-8 justify-start h-full w-full"
                  >
                    <div class="flex justify-center items-center gap-2">
                      <img
                        src="@/assets/home/programs/graduation-cap.svg"
                        alt="graduation-cap"
                      />
                      <p class="text-xs md:text-sm text-white">
                        {{ el.program.short_name }}
                      </p>
                    </div>
                    <div class="flex justify-center items-center gap-2">
                      <img
                        src="@/assets/home/programs/Iconfeather-calendar.webp"
                        alt="graduation-cap"
                      />
                      <p class="text-xs md:text-sm text-white">
                        {{ el.duration }} Years
                      </p>
                    </div>
                    <div class="flex justify-center items-center gap-2">
                      <img
                        src="@/assets/home/programs/money.png"
                        alt="graduation-cap"
                      />
                      <p class="text-xs md:text-sm text-white">
                        {{ formatCurrency(el.program_fee) }}
                      </p>
                    </div>
                  </div>
                  <div class="text-start text-white">
                   
                      <button class="border-b border-yellow-400">
                        Know more
                      </button>
                   
                  </div>
                </div>
              </a>
              </div>
              <!-- mobile master degrees -->
             
              <div class="md:hidden relative">
                <a
                  :href="`/${el.program.short_slug}/${el.slug}`"
                >
                <img
                  :src="el.elective_mobile_image"
                  :alt="el.name"
                  class="rounded-[25px] shadow-xl w-full h-full object-cover"
                />
                <div
                  class="absolute bottom-0 h-auto min-h-[160px] flex flex-col gap-2 p-4"
                >
                  <h2 class="text-white text-[24px] font-medium text-start">
                    {{ el.name }}
                  </h2>
                  <p
                    class="text-white text-[14px] font-medium text-start line-clamp-2"
                    v-html="el.description"
                  ></p>
                  <div
                    class="flex gap-4 md:gap-6 lg:gap-8 justify-start h-full w-full"
                  >
                    <div class="flex justify-center items-center gap-2">
                      <img
                        src="@/assets/home/programs/graduation-cap.svg"
                        alt="graduation-cap"
                      />
                      <p class="text-xs md:text-sm text-white">
                        {{ el.program.short_name }}
                      </p>
                    </div>
                    <div class="flex justify-center items-center gap-2">
                      <img
                        src="@/assets/home/programs/Iconfeather-calendar.webp"
                        alt="graduation-cap"
                      />
                      <div class="text-xs md:text-sm text-white">
                        {{ el.duration }} Years
                      </div>
                    </div>
                    <div class="flex justify-center items-center gap-2">
                      <img
                        src="@/assets/home/programs/money.png"
                        alt="graduation-cap"
                      />
                      <p class="text-xs md:text-sm text-white">
                        {{ formatCurrency(el.program_fee) }}
                      </p>
                    </div>
                  </div>
              
                </div>
              </a>
              </div>
          
              <!-- <div class="block md:hidden w-full text-start text-white py-4">
                <a
                  v-if="
                    el.program.short_slug !== 'online-mba' ||
                    el.slug !== 'artificial-intelligence'
                  "
                  :href="`/${el.program.short_slug}/${el.slug}`"
                >
                  <button
                    class="w-full py-[13px] text-[#001c54] border bg-[#f8c300] rounded-3xl button-cta"
                  >
                    Know more
                  </button>
                </a>
              </div> -->
              <div class="block md:hidden w-full text-start text-white py-4">
                <a
                  :href="`/${el.program.short_slug}/${el.slug}`"
                >
                  <button
                    class="w-full py-[13px] text-[#001c54] border bg-[#f8c300] rounded-3xl button-cta"
                  >
                    Know more
                  </button>
              </a>
              </div>
            </div>
            
          </div>
          <!-- Load more button -->
          <div
            v-if="shouldShowLoadMore"
            class="w-full flex justify-center items-center"
          >
            <button
              @click="loadMore"
              class="w-full md:w-[180px] py-[13px] text-[16px] text-[#001c54] border border-[#001c54] rounded-3xl button-cta"
            >
              Load more
            </button>
          </div>
          <!-- Load more button -->
          <!-- Load less button -->
          <div
            v-if="shouldShowLoadLess"
            class="w-full flex justify-center items-center"
          >
            <button
              @click="loadLess"
              class="w-full md:w-[180px] py-[13px] text-[16px] text-[#001c54] border border-[#001c54] rounded-3xl font-semibold"
            >
              Load less
            </button>
          </div>
          <!-- Load less button -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MasterView",
  data() {
    return {
      electiveData: [],
      programId: null,
      cardsToShow: 6,
    };
  },
  created() {
    this.fetchElectives();
  },
  watch: {
    "$route.params.slug": "fetchElectives",
  },
  methods: {
    async fetchElectives() {
      const slug = this.$route.params.slug;
      await axios
        .get(`${process.env.VUE_APP_API}/course/program-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            const program = resp.data.data.find(
              (program) => program.slug === slug
            );
            if (program) {
              this.programId = program.id;
              this.fetchElectiveData();
            } else {
              console.log("Program not found for slug:", slug);
            }
          }
        })
        .catch((error) => {
          console.log("Error fetching program:", error);
        });
    },
    async fetchElectiveData() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/course/elective-list/?program__id=${this.programId}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.electiveData = resp.data.data;
          }
        })
        .catch((error) => {
          console.log("Error fetching elective data:", error);
        });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value);
    },
    loadMore() {
      this.cardsToShow += 3;
    },
    loadLess() {
      this.cardsToShow = 6;
    },
  },
  computed: {
    shouldShowLoadMore() {
      return this.electiveData.length > this.cardsToShow;
    },
    shouldShowLoadLess() {
      return (
        this.cardsToShow > 6 && this.electiveData.length <= this.cardsToShow
      );
    },
    visibleElectiveData() {
      return this.electiveData.slice(0, this.cardsToShow);
    },
  },
};
</script>

<style></style>
